import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify, {
  theme: {
    primary: '#0A94C5',
    secondary: '#123644',
    tertiary: '#D3D3D3',
    accent: '#FE8402',
    error: '#FF5252',
    info: '#206be5',
    success: '#0ab25b',
    warning: '#FFA500',
    dark: '#000000',
    grey: '#F5F5F5'
  }
})